import { render, staticRenderFns } from "./CartAdmin.vue?vue&type=template&id=3c38a239"
import script from "./CartAdmin.vue?vue&type=script&lang=js"
export * from "./CartAdmin.vue?vue&type=script&lang=js"
import style0 from "./CartAdmin.vue?vue&type=style&index=0&id=3c38a239&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports